import React from "react";
import "./PaymentDonePage.css";
import verifiedLogo from "./image/verified-logo.png";
import foodImg from "./image/food-img.png";

import { RiArrowDropDownLine } from "react-icons/ri";
import { SlCalender } from "react-icons/sl";
import { IoMdStopwatch } from "react-icons/io";
import { TbUsers } from "react-icons/tb";
import { IoLocationOutline } from "react-icons/io5";
import { GiNotebook } from "react-icons/gi";
import { GiSandsOfTime } from "react-icons/gi";


export default function PaymentDonePage() {
    return (
        <>
            <div className="payment-done-container">
                <div className="payment-card-d">
                    <div className="success-icon-d"><img src={verifiedLogo} alt="" /></div>
                    <h2 className="success-text-d">Payment Successful!</h2>

                    <div className="booking-status-container-d">
                        <div className="booking-status-d">
                            <p><span className="status-icon-d"><GiSandsOfTime size={25}/></span>  Waiting for Booking Confirmation<br /></p>
                            <div className="status-text-d">
                                <p>
                                    We’ve notified <a href="#">Veggies Garden Palace</a> about your
                                    booking. You’ll receive a confirmation once the restaurant accepts
                                    your request.
                                </p>
                            </div>
                        </div>

                        <div className="summary-section-d">
                            <div className="summary-header-d">
                                <span className="summary-title-d">📋 View Party Summary</span>
                                <RiArrowDropDownLine  size={25}/>
                            </div>
                            <div className="summary-body-d">
                                <img
                                    src={foodImg}
                                    alt="Party"
                                    className="summary-image-d"
                                />
                                <div className="summary-details-d">
                                    <h4>Pure Vegetarian Food Party</h4>
                                    <p className="venue-d">Veggies Garden Palace</p>
                                    <p><SlCalender /> 14 April 2025</p>
                                    <p><IoMdStopwatch /> 10PM - 1AM</p>
                                    <p><TbUsers /> 4 Guests</p>
                                    <p><IoLocationOutline/> Block K, Lajpat Nagar IV, Lajpat Nagar, New Delhi, Delhi 110048</p>
                                    <div className="badge-group-d">
                                        <span className="badge-d">Get Directions</span>
                                        <span className="badge paid-d">Amount Paid ₹ 2010</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="note-d">
                        <GiNotebook/> <strong>Note:</strong> Your booking will only be confirmed once the
                        restaurant accepts. You won’t be charged further until the full confirmation.
                    </div>
                </div>
            </div>
        </>
    );
}
